const months = () => {
  return [
    { value: 'january', label: 'January' },
    { value: 'february', label: 'February' },
    { value: 'march', label: 'March' },
    { value: 'april', label: 'April' },
    { value: 'may', label: 'May' },
    { value: 'june', label: 'June' },
    { value: 'july', label: 'July' },
    { value: 'august', label: 'August' },
    { value: 'september', label: 'September' },
    { value: 'october', label: 'October' },
    { value: 'november', label: 'November' },
    { value: 'december', label: 'December' },
  ];
};
export const montListWithMonthNuber = [{ value: 0, label: 'january' },
{ value: 1, label: 'february' },
{ value: 2, label: 'march' },
{ value: 3, label: 'april' },
{ value: 4, label: 'may' },
{ value: 5, label: 'june' },
{ value: 6, label: 'july' },
{ value: 7, label: 'august' },
{ value: 8, label: 'september' },
{ value: 9, label: 'october' },
{ value: 10, label: 'november' },
{ value: 11, label: 'december' }]


export default months;
